<template>
	<div class="v-table__overflow proposal-table">
		<table class="v-table" :class="!dark ? 'theme--light' : 'theme--dark'">
			<thead>
				<tr>
					<th
						role="columnheader"
						scope="col"
						aria-label="Item: Not sorted."
						aria-sort="none"
						class="column text-xs-left"
						width="50%"
					>
						Item
					</th>

					<th
						role="columnheader"
						scope="col"
						aria-label="Options: Not sorted."
						aria-sort="none"
						class="column text-xs-left"
					>
						Options
					</th>
				</tr>
			</thead>

			<tbody
				v-for="line_item in parts"
				:key="line_item.id"
				:line_item="line_item"
				:line_items_editable="line_items_editable"
				:document="document"
				is="proposal-table-line-item"
				class="proposal-table__line-item"
			></tbody>

			<tfoot>
				<tr v-if="document.show_line_item_prices">
					<td>TOTAL SUGGESTED LIST PRICE:</td>

					<th class="title text-xs-right">
						{{ list_total | currency }}
					</th>
				</tr>
				<tr v-if="surchargeper > 0">
					<td>SURCHARGE ({{surchargeper}}%):</td>
					<th class="title text-xs-right">
						{{ surchargeamount | currency }}
					</th>
				</tr>
				<tr v-if="!document.for_customer && document.show_net_price">
					<td>TOTAL DEALER NET PRICE:</td>
					<th class="title text-xs-right">
						{{ net_total + surchargeamount | currency }}
					</th>
				</tr>

				<tr
					v-if="document.for_customer && document.show_customer_price"
				>
					<td>TOTAL END USER PRICE:</td>
					<th class="title text-xs-right">
						{{ document_total + surchargeamount | currency }}
					</th>
				</tr>
			</tfoot>
		</table>
		<!-- <code>{{document}}</code> -->
	</div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import CurrencyInput from "@components/partials/CurrencyInput";
import ProposalTableLineItem from "@components/partials/ProposalTableLineItem";
var { quoteBuilder } = require("@root/mixins");

export default {
	mixins: [quoteBuilder],

	data() {
		return {};
	},

	props: {
		line_items_editable: {
			default: false
		}
	},

	components: { CurrencyInput, ProposalTableLineItem },

	computed: {
		...mapGetters(["dark", "user", "privacy"]),

		line_items() {
			return this.document.line_items;
		},

		parts() {
			return _.filter(this.line_items, item => item.part_id);

		},

		document_total() {
			return this.total();
		},

		list_total() {
			return this.total("list_price", "configuration_price");
		},
	     surchargeper(){
			 var sum_surcharge=0;

		     this.line_items.map(function(item){
				 if(parseFloat(item.surcharge_per!=null?item.surcharge_per:0)!=0)
				 sum_surcharge=parseFloat(item.surcharge_per!=null?item.surcharge_per:0);
			 })
			 return (sum_surcharge)
		},
        surchargeamount(){
			return this.line_items.reduce((acc, item) => acc + parseFloat(item.surcharge_amount!=null?item.surcharge_amount:0),0);
		},
		net_total() {
			return this.total("modified_price", "modified_configuration_price");
		},

		total() {
			return (field = "quote_price", offsetField = false) => {
				return this.document.line_items.reduce((carry, item) => {
					carry +=
						(item[field] + (offsetField ? item[offsetField] : 0)) *
						item.quantity;

					return carry;
				}, 0);
			};
		},

		show_list_prices() {
			if (this.privacy) {
				return false;
			}

			return this.show_line_item_prices;
		}
	},

	methods: {
		...mapActions("documents", {
			UPDATE_DOCUMENT_FIELD: "updateDocumentField"
		})
	}
};
</script>
